import Breadcrumbs from "../../../coreComponents/breadcrumbs"
import { Configuration, FarmerTitle } from "../../../constants"
import { Container, Card, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

import CommonCardHeader from "../../../coreComponents/CommonCardHeader"
import { useNavigate } from "react-router-dom"
import routes from "../../../routers/routes"
import { useAppSelector } from "../../../reduxToolkit/hooks"
import { useEffect, useState, useCallback } from "react"
import ApiService from "../../../services/apiService"
import { toast } from 'react-toastify'
import Table from "../../table/Table"
import { usePagination } from "../../../hooks/usePagination"
import LeftIcon from "../../svg/LeftButton"
import RightIcon from "../../svg/RightIcon"
import FilterIcon from "../../svg/FilterIcon"
const Farmer = () => {

    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [farmerData, setFarmerData] = useState<any>([]);
    const [selectedId, setSelectedId] = useState("");
    const [userData, setUserData] = useState([]);
    const [userDetails, setUserDetails] = useState<any>([]);
    const role = useAppSelector((state: any) => state.role.role);

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy
    } = usePagination({
        endpoint: `/farmer`,
        filterOn: 'FarmerName',
        enabled: true
    })

    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])



    const deleteFarmer = (id: string) => {

        setSelectedId(id);
        setIsDeleteModalOpen(true);
    }

    const handleUpdate = (id: string) => {
        console.log(id);
        navigate(`/farmer-update/${id}`)
    }

    const handleDeleteFarmer = async (selectedId: string) => {

        try {

            const response = await ApiService.axiosApi(`/farmer/${selectedId}`, {
                method: 'DELETE'

            })
            if (response.success) {
                toast.success(response.message || "Farmer Deleted Successsfully")
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev)
            }
        } catch (error: any) {
            console.log(error);
            toast.error("Unable to Delete Farmer ")
        }
    }

    return (
        <>
            <Breadcrumbs mainTitle={FarmerTitle} parent={Configuration} />
            <div className="tables">
                <Card>

                    <CommonCardHeader title="Farmer List" headClass="pb-3" />
                    <div className="d-flex justify-content-between">

                        <div style={{ marginLeft: '10px',justifyContent:'space-between' }} className='  d-flex '>
                            <div>
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="...search"
                                    value={searchQuery}
                                    onChange={(e) => {
                                        setSearchQuery(e.target.value)
                                        setPageNumber(1)
                                    }}

                                />
                            </div>
                            <div className='d-flex align-items-center'>
                                <button className="filter-button mx-2 p-1" style={{ height: '30px' }} onClick={() => setSortBy('FarmerName')}>
                                    <FilterIcon />
                                </button>
                            </div>

                        </div>
                        {role === "Administrator" && (
                            <div className="d-flex justify-content-end">
                                <Button onClick={() => navigate(routes.AddFarmer)} color="primary" className="mb-2 mx-2">Add Farmer</Button>
                            </div>
                        )}
                    </div>
                    <Table data={data}
                        columns={[
                            { header: "Farmer Name", accessor: "farmerName" },
                            { header: "Mobile Number", accessor: "mobileNo" },
                            { header: "Email", accessor: "emailAddress" },
                            { header: "Address", accessor: "address" },
                            { header: "Village", accessor: 'schemeVillage' }

                        ]}
                        buttons={[
                            { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: deleteFarmer, color: "danger" }
                        ]}
                    />
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>

                </Card>
                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Farmer</ModalHeader>
                    <ModalBody>Are you sure you want to delete this Farmer?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteFarmer(selectedId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
    )
}

export default Farmer;